module.exports = __webpack_public_path__ + "static/media/mariposa_big.6dd5b855.png";